<div class="workSpace">
   <!-- Titulo -->
  <div class="w3-container w3-container-template headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
  </div>
  <!-- TABLERO -->
  <div class="w3-row workSpaceTab" style="overflow: scroll;">
    <div class="w3-container w3-contenedor-template" style="height: 100%;" id="img-1">
      <div class="w3-row contenerdorObj mantenerFija">
        @if(mision !== undefined){
          <div class="filosofiaCMI">
            <div class="w3-row tituloFilosofiaCMI">{{mision.name}}</div>
            <div class="w3-row contenidoFilosofiaCMI" matTooltipPosition="right" matTooltip="{{mision.description}}">
              <span>{{mision.description}}</span>
            </div>
          </div>
        }
        @if (vision !== undefined) {
          <div class="filosofiaCMI">
            <div class="w3-row tituloFilosofiaCMI">{{vision.name}}</div>
            <div class="w3-row contenidoFilosofiaCMI" matTooltipPosition="right" matTooltip="{{vision.description}}">
              <span>{{vision.description}}</span>
            </div>
          </div>
        }
        
        <div class="w3-right" style="z-index: 1; margin-top: 1vh;" id="menu-exp">
          <mat-icon class="w3-margin-right-contenido w3-zindex w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          @if (tarjOrTab) {
            <button (click)="imprimirImg()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          }@else {
            <button (click)="exportarTab()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          }
          
          
          <button (click)="tarjOrTab = !tarjOrTab" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            @if (tarjOrTab) {
              <ng-container>
                <mat-icon [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                <span>{{'gestion.formulacion.cuadro-mando.optTabla' | translate}}</span>
              </ng-container>              
            }@else {
              <ng-container>
                <mat-icon [ngStyle]="{'color':'gray'}">crop_landscape</mat-icon>
                <span >{{'gestion.formulacion.cuadro-mando.optTarjetas' | translate}}</span>
              </ng-container>
            }
          </button>
        </mat-menu>
      </div>
      @if (tarjOrTab) {
        @for (per of diccionarioPerspectivas; track per; let j = $index) {
          <div class="w3-titulo-contenidomenu">
            <span class="w3-margin-left-contenido"> {{per.perspectiva.nombre}} </span>
          </div>
          <div class="w3-row w3-margin-left-contenido">
            @for (obj of per.objetivos; track obj; let i = $index) {
              <div class="w3-third_e">
                <div class="card">
                  <div class="card-badge" [ngClass]="color(j)">
                    <span class="badge-code">{{obtLet(per)}}{{i+1}}</span>
                  </div>
                  <div class="card-content">
                    <div class="content-top">
                      <p class="card-title">{{obj.nombre}}</p>
                        <mat-icon class="w3-margin-right-contenido  w3-button" [ngStyle]="{'color':'gray'}" (click)="modal_ind(obj,per,i)">
                            <span class="material-icons-outlined">info_outline</span>
                          </mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }@else {
        <div class="w3-row contenedorTable">
          <div class="tablaCont">
            <table class="w3-table">
              <thead>
                <tr class="w3-table-titleLow w3-center">
                  <th class="w3-border-right-balance encabezados">{{'gestion.formulacion.cuadro-mando.titTab1' | translate}}</th>
                  <th class="w3-border-right-balance encabezados">{{'gestion.formulacion.cuadro-mando.titTab2' | translate}}</th>
                  <th class="w3-border-right-balance encabezados">{{'gestion.formulacion.cuadro-mando.titTab3' | translate}}</th>
                  <th class="w3-border-right-balance encabezados marginsH">{{'gestion.formulacion.cuadro-mando.titTab4' | translate}}</th>
                </tr>
              </thead>
              <tbody class="borderInf borderIzq">
                @for (per of diccionarioPerspectivas; track $index) {
                  @for (obj of per.objetivos; track obj; let i = $index) {
                    @for (ind of obj.indicators; track ind; let j = $index) {
                      <tr class="w3-table-trtd">
                        @if (i === 0 && j === 0) {<td class="borderLowSup borderLowIzq">{{per.perspectiva.nombre}}</td>}
                        @if (i !== 0 || j !== 0) {<td class="borderLowIzq"></td>}
                        @if (j === 0) {<td class="borderLowSup borderLowIzq marginsH">{{obj.nombre}}</td>}
                        @if (j !== 0) {<td class="borderLowIzq"></td>}
                        <td class="borderAllLow marginsH">{{ind.name}}</td>
                        <td class="alinRight borderAllLow marginsH">{{ind.weighing}}</td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>